var _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 14.3995C2.90039 12.9712 2.90145 11.9502 3.00577 11.1743C3.10815 10.4128 3.30167 9.96272 3.63262 9.63177C3.96358 9.30081 4.4137 9.10729 5.1752 9.00491C5.95108 8.9006 6.97204 8.89954 8.40039 8.89954H12.0004C13.4287 8.89954 14.4497 8.9006 15.2256 9.00491C15.9871 9.10729 16.4372 9.30081 16.7682 9.63177L17.1217 9.27822L16.7682 9.63177C17.0991 9.96272 17.2926 10.4128 17.395 11.1743C17.4993 11.9502 17.5004 12.9712 17.5004 14.3995C17.5004 15.8279 17.4993 16.8488 17.395 17.6247C17.2926 18.3862 17.0991 18.8363 16.7682 19.1673C16.4372 19.4983 15.9871 19.6918 15.2256 19.7942C14.4497 19.8985 13.4287 19.8995 12.0004 19.8995H8.40039C6.97204 19.8995 5.95108 19.8985 5.1752 19.7942C4.4137 19.6918 3.96358 19.4983 3.63262 19.1673C3.30167 18.8363 3.10815 18.3862 3.00577 17.6247C2.90145 16.8488 2.90039 15.8279 2.90039 14.3995Z",
    fill: "white",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.19883,
    cy: 4.79917,
    r: 1.9,
    fill: "white",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1988,
    cy: 4.79917,
    r: 1.9,
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3008 16.4611V12.3381L21.6151 10.6124C21.9435 10.481 22.3008 10.7229 22.3008 11.0766V17.7226C22.3008 18.0763 21.9435 18.3182 21.6151 18.1868L17.3008 16.4611Z",
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d6244cba6e4e1ba6f1294e158736b5a2.svg";
export { ForwardRef as ReactComponent };